import subsetNames from './material-symbols-subset-names.json';

const SUBSET_NAMES: ReadonlySet<string> = new Set(subsetNames);

/** `yarn icons:subset` regenerates this list together with the subset font. */
export const isInMaterialSymbolsSubset = (name: string) => SUBSET_NAMES.has(name);
